import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Options } from 'vue-class-component';
import AvalonGTView from '@/utils/libs/BaseView';
import NavPanel from '@/components/common/NavPanel.vue';
import { PageService } from '@/views/copy/invite/import';
import NoticeScroll from '@/views/copy/invite/page/components/NoticeScroll.vue';
import { AvalonGTEvent } from '@/utils/Event';
import Qrcode from '@/views/copy/invite/page/Qrcode.vue';
import QrcodeApp from '@/views/copy/invite/page/QrcodeApp.vue';
import AvalonGTGlobal from '@/utils/factory/Global';
import { Toast } from 'vant';
import commonConfig from '@/common/CommonConfig';
import UnbindDialog from '@/views/copy/invite/page/components/UnbindDialog.vue';
import moment from 'moment';
import IncomeContent from '@/views/copy/invite/page/components/IncomeContent.vue';
import CommonService from '@/service/Common';
import myDialog from '@/components/assist/dialog.vue';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showUnbindDialog = false;
        _this.componentId = null;
        _this.tabList = [
            {
                title: '我的邀请',
                index: 2,
                component: 'InvitePanel',
            },
            {
                title: '邀请奖励',
                index: 1,
                component: 'InvitePanel',
            },
        ];
        _this.tabActive = {
            tabIndex: 2,
            component: 'incomePanel',
        }; //@ 2021/12/20 14:08 当前所在的tab
        _this.inviteList = []; //@ 2021/12/20 14:28 邀请列表数据
        _this.inviteInfo = {}; //@ 2021/12/21 10:54 用户邀请信息
        _this.type = 1; //@ 2021/12/21 14:10 从哪里跳转进来的  1.APP 2.微信
        _this.pageIndex = 1; //@ 2021/12/21 17:32 分页的页数
        _this.navH = 0;
        _this.statusH = 0;
        _this.currentDate = moment().format('YYYY-MM-DD'); // 2022/7/11 16:52 时间
        _this.bannerList = []; // 2022/8/12 13:52 banner展示
        _this.h5Config = {}; // 2022/8/24 16:33 是否展示邀请好友
        _this.package = '';
        _this.showDialog = false;
        return _this;
    }
    View.prototype.created = function () {
        var _this = this;
        this.package =
            this.awlGlobalState.urlInitParams.package && this.awlGlobalState.urlInitParams.package != 'undefined'
                ? this.awlGlobalState.urlInitParams.package
                : 'chuai';
        // let inviteTabIndex: any = localStorage.getItem('inviteTabIndex');
        // if (inviteTabIndex) {
        this.tabActive.tabIndex = this.awlGlobalState.Invite2Tabindex;
        // }
        // console.log('this.tabActive', this.tabActive.tabIndex);
        this.type = this.awlGlobalState.urlInitParams.type;
        this.navH = this.awlGlobalState.urlInitParams.navH;
        this.statusH = this.awlGlobalState.urlInitParams.statusH;
        this.inviteList = [];
        this.pageIndex = 1;
        window['doReloadData'] = function () {
            _this.doReloadData();
        };
        this.getH5Config();
        this.switchComponent();
        this.globalCommit('setting_pageJump', 1);
        console.log('invite----created');
    };
    View.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInviteInfo()];
                    case 1:
                        _a.sent();
                        this.$nextTick(function () {
                            _this.$refs.content.getInviteList(_this.tabActive.tabIndex, _this.inviteInfo.inviteUserType);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    // 2022/8/16 15:21 获取h5通用config
    View.prototype.getH5Config = function () {
        var _this = this;
        CommonService.getInstance()
            .getH5Config({})
            .then(function (data) {
            _this.h5Config = data;
        });
    };
    /*
     *@参数:
     *@开发者:
     *@创建时间: 2024-09-03 15:02:44
     *@功能:切换二维码组件
     */
    View.prototype.switchComponent = function () {
        var _this = this;
        if (this.awlGlobalConfig.platformNameBodyObj.isInviteQrcode) {
            this.componentId = QrcodeApp;
            //  2024-09-03 15:09:06：判断是否在默认组件白名单中
        }
        else if (this.awlGlobalState.defaultComponentList.includes(this.package)) {
            this.componentId = Qrcode;
        }
        else {
            import("./Qrcode" + this.package + ".vue")
                .then(function (module) {
                _this.componentId = module.default;
            })
                .catch(function (err) {
                //  2024-09-03 15:27:30：未加载成功的话，就加载默认组件
                _this.componentId = Qrcode;
            });
        }
    };
    //@ 2021/12/20 16:39 点击tab
    View.prototype.tabHandle = function (item) {
        this.tabActive.tabIndex = item.index;
        this.globalCommit('setting_Invite2Tabindex', item.index);
        this.tabActive.component = item.component;
        this.inviteList = [];
        this.pageIndex = 1;
        this.$refs.content.tabHandle(item.index, this.inviteInfo.inviteUserType, item);
    };
    //@ 2021/12/21 10:05 获取用户邀请信息
    View.prototype.getInviteInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, PageService.getUserInvite({})];
                    case 1:
                        data = _a.sent();
                        this.inviteInfo = data;
                        this.bannerList = data.bannerList ? data.bannerList : [];
                        this.sharePic();
                        localStorage.removeItem('inviteTabIndex');
                        // data.startDate = moment(data.createdAt).format('YYYY-MM-DD');
                        // data.endDate = moment().format('YYYY-MM-DD');
                        this.inviteInfo.minDate = new Date(moment(data.createdAt).format('YYYY-MM-DD'));
                        this.inviteInfo.maxDate = new Date(moment().format('YYYY-MM-DD'));
                        params = {};
                        // 2022/8/12 10:43 判断是否是超推 若是超推得话  就传1  若不是超推  则传空
                        if (data.userType == '3') {
                            params = {
                                startDate: data.startDate,
                                endDate: data.endDate,
                            };
                        }
                        else {
                            params = {};
                            // this.getKeFuUrl();
                        }
                        this.getInviteStats(params);
                        return [2 /*return*/];
                }
            });
        });
    };
    // 2023/11/21 13:22  邀请统计
    View.prototype.getInviteStats = function (params) {
        var _this = this;
        PageService.getInviteStats(params).then(function (data) {
            _this.inviteInfo.inviteCount = data.inviteCount;
            _this.inviteInfo.inviteCountWeek = data.inviteCountWeek;
            _this.inviteInfo.incomeToday = data.incomeToday;
            _this.inviteInfo.incomeWeek = data.incomeWeek;
            _this.inviteInfo.income = data.income;
        });
    };
    //@ 2021/12/21 14:15 跳转规则页面
    View.prototype.toRules = function () {
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/invitationRules',
        });
    };
    //@ 2021/12/22 13:39 复制
    View.prototype.copyHandle = function (val) {
        console.log('val====', val);
        AvalonGTGlobal.copyText(val);
    };
    //@ 2021/12/22 19:30 生成图片
    View.prototype.sharePic = function () {
        var params = {
            imageUrl: this.inviteInfo.userAvatar,
            code: this.inviteInfo.inviteCode,
            title: this.inviteInfo.shareTitle,
            subtitle: this.inviteInfo.shareText,
            url: this.inviteInfo.shareLink + this.inviteInfo.inviteCode + '&package=' + this.package,
            nickName: this.inviteInfo.userNickname,
        };
        AvalonGTEvent.eventHub.emit(AvalonGTEvent.Global.GENERATE_PIC, params);
    };
    //@ 2021/12/21 16:06 分享
    View.prototype.shareHandle = function (type, isShowToast) {
        var _this = this;
        if (type == 1) {
            Toast('正在生成海报');
        }
        else {
            if (isShowToast != 1) {
                AvalonGTGlobal.copyText(this.inviteInfo.shareLink + this.inviteInfo.inviteCode + '&package=' + this.package, '已复制链接');
            }
        }
        clearInterval(this.timer);
        this.timer = null;
        if (this.awlGlobalState.imageBase) {
            this.share(type);
        }
        else {
            this.timer = setInterval(function () {
                _this.shareHandle(type);
            }, 500);
        }
    };
    //@ 2021/12/25 14:35 判断图片是否生成
    View.prototype.share = function (type) {
        Toast.clear();
        // let qrcode: any = this.$refs.qrcode
        var params = {
            route: commonConfig.Common.APPRoutes.feedback,
            action: type,
            imageBase64: this.awlGlobalState.imageBase,
            imageUrl: this.inviteInfo.userAvatar,
            code: this.inviteInfo.inviteCode,
            title: this.inviteInfo.shareTitle,
            subtitle: this.inviteInfo.shareText,
            url: this.inviteInfo.shareLink + this.inviteInfo.inviteCode + '&package=' + this.package,
            copy: this.inviteInfo.shareText +
                "\n\n" +
                this.inviteInfo.shareTitle +
                "\n" +
                this.inviteInfo.shareLink +
                this.inviteInfo.inviteCode +
                '&package=' +
                this.package,
        };
        console.log('params', params);
        console.log('params.route', params.route);
        console.log('params.action', params.action);
        this.awlGlobalConfig.messageHandlers(params);
    };
    View.prototype.showHelp = function () {
        this.showDialog = true;
    };
    //@ 2021/12/25 16:01 原生调用js
    View.prototype.doReloadData = function () {
        return;
        this.pageIndex = 1;
        this.inviteList = [];
        this.$refs.content.tabHandle(this.tabActive.tabIndex, this.inviteInfo.inviteUserType, this.tabActive);
        console.log('原生执行刷新列表');
    };
    // 2022/1/22 14:59 跳转邀请说明
    View.prototype.toProtocal = function () {
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/invitationRules',
            query: {
                rechargeCommissionRate: this.inviteInfo.rechargeCommissionRate,
                commissionRate: this.inviteInfo.commissionRate,
            },
        });
    };
    // 2023/10/23 10:05 邀请补填
    View.prototype.toSupplement = function () {
        var params = {
            isSupper: this.inviteInfo.userType == '3' || this.inviteInfo.userType == '1' ? true : false,
            navH: this.awlGlobalState.urlInitParams.navH,
            statusH: this.awlGlobalState.urlInitParams.statusH,
            version: this.awlGlobalState.urlInitParams.version,
            token: this.awlGlobalState.urlInitParams.token,
        };
        this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
        this.$router.push({
            path: '/nav/supplement',
            query: params,
        });
        // this.getRoute();
    };
    // 2022/8/3 15:01 选择时间
    View.prototype.confirmDate = function (e) {
        this.currentDate = e;
    };
    View.prototype.onCalendarConfirm = function (params) {
        this.getInviteStats(params);
    };
    // 2022/7/12 13:42 导出当日收益明细
    View.prototype.exportExcelDay = function () {
        var params = {
            action: 14,
            url: this.awlGlobalConfig.ServiceBaseUrl +
                '/userInvite/exportExcelDay?date=' +
                this.currentDate +
                '&ttno=' +
                this.inviteInfo.downloadTTno +
                '&sign=' +
                this.inviteInfo.downloadToken,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    View.prototype.exportExcelWeek = function () {
        var params = {
            action: 14,
            url: this.awlGlobalConfig.ServiceBaseUrl +
                '/userInvite/exportExcelWeek?ttno=' +
                this.inviteInfo.downloadTTno +
                '&sign=' +
                this.inviteInfo.downloadToken,
        };
        this.awlGlobalConfig.messageHandlers(params);
    };
    // 2022/8/12 14:03 跳转到客服入口
    View.prototype.toKefu = function () {
        // window.open('http://www.baidu.com','_blank'); http://47.110.181.140/yrr/export
        // if (this.kefuUrl) {
        var params = {};
        this.awlGlobalConfig.gotoKfService();
        // }
    };
    // 2022/8/1 13:55 跳转到url上
    View.prototype.toPage = function (item) {
        if (item.linkUrl) {
            this.globalCommit('setting_pageJump', Number(this.awlGlobalState.pageJump) + 1);
            var params = {
                action: 3,
                url: item.linkUrl,
                isImmersive: true,
            };
            this.awlGlobalConfig.messageHandlers(params);
        }
    };
    // 2022/8/23 15:36 好友管理弹窗
    View.prototype.showDialogHandle = function () {
        this.awlEventHub.emit(AvalonGTEvent.Global.FRIEND_MANAGE, this.h5Config.isBindFriends);
    };
    View.prototype.toBack = function () {
        this.globalCommit('setting_pageJump', 1);
        this.awlGlobalConfig.onBack();
    };
    View = __decorate([
        Options({
            components: {
                IncomeContent: IncomeContent,
                UnbindDialog: UnbindDialog,
                NoticeScroll: NoticeScroll,
                NavPanel: NavPanel,
                Qrcode: Qrcode,
                QrcodeApp: QrcodeApp,
                myDialog: myDialog,
            },
        })
    ], View);
    return View;
}(AvalonGTView.BaseView));
export default View;
